var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstPrize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_705_44727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7449 8.80344C17.632 8.61519 17.4285 8.5 17.209 8.5H11.1667C10.6809 8.5 10.3809 9.02998 10.6308 9.44656L17.3808 20.6966C17.4938 20.8848 17.6972 21 17.9167 21H23.959C24.4448 21 24.7449 20.47 24.4949 20.0534L17.7449 8.80344Z",
    fill: "#C52229"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.209 7.875H11.1667C10.1951 7.875 9.59499 8.93496 10.0949 9.76812L16.8449 21.0181C17.0708 21.3946 17.4777 21.625 17.9167 21.625H23.959C24.9306 21.625 25.5308 20.565 25.0309 19.7319L18.2809 8.48188C18.055 8.10537 17.6481 7.875 17.209 7.875ZM17.209 8.5C17.4285 8.5 17.632 8.61519 17.7449 8.80344L24.4949 20.0534C24.7449 20.47 24.4448 21 23.959 21H17.9167C17.6972 21 17.4938 20.8848 17.3808 20.6966L10.6308 9.44656C10.3809 9.02998 10.6809 8.5 11.1667 8.5H17.209Z",
    fill: "#9B0F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.256 8.80344C24.369 8.61519 24.5724 8.5 24.792 8.5H30.8342C31.3201 8.5 31.6201 9.02998 31.3702 9.44656L24.6202 20.6966C24.5072 20.8848 24.3038 21 24.0842 21H18.042C17.5562 21 17.2561 20.47 17.506 20.0534L24.256 8.80344Z",
    fill: "#F1333B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.792 7.875H30.8342C31.8058 7.875 32.406 8.93496 31.9061 9.76812L25.1561 21.0181C24.9302 21.3946 24.5233 21.625 24.0842 21.625H18.042C17.0704 21.625 16.4702 20.565 16.9701 19.7319L23.7201 8.48188C23.946 8.10537 24.3529 7.875 24.792 7.875ZM24.792 8.5C24.5724 8.5 24.369 8.61519 24.256 8.80344L17.506 20.0534C17.2561 20.47 17.5562 21 18.042 21H24.0842C24.3038 21 24.5072 20.8848 24.6202 20.6966L31.3702 9.44656C31.6201 9.02998 31.32 8.5 30.8342 8.5H24.792Z",
    fill: "#9B0F15"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9075 8.8548C25.0567 8.94147 25.1074 9.13272 25.0208 9.28197L22.2083 14.1257C22.1216 14.275 21.9304 14.3257 21.7811 14.239C21.6319 14.1524 21.5811 13.9611 21.6678 13.8119L24.4803 8.96813C24.567 8.81888 24.7582 8.76814 24.9075 8.8548Z",
    fill: "#FE666D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.156 8.8548C11.0068 8.94147 10.956 9.13272 11.0427 9.28197L13.8552 14.1257C13.9419 14.275 14.1331 14.3257 14.2824 14.239C14.4316 14.1524 14.4823 13.9611 14.3957 13.8119L11.5832 8.96813C11.4965 8.81888 11.3053 8.76814 11.156 8.8548Z",
    fill: "#DF3840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0942 9.52539C17.0942 9.74652 16.9193 9.92578 16.7036 9.92578C16.4879 9.92578 16.313 9.74652 16.313 9.52539C16.313 9.30426 16.4879 9.125 16.7036 9.125C16.9193 9.125 17.0942 9.30426 17.0942 9.52539Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7223 9.62305C15.7223 9.89811 15.5047 10.1211 15.2364 10.1211C14.968 10.1211 14.7505 9.89811 14.7505 9.62305C14.7505 9.34798 14.968 9.125 15.2364 9.125C15.5047 9.125 15.7223 9.34798 15.7223 9.62305Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9381 11.0488C16.9381 11.3239 16.7206 11.5469 16.4522 11.5469C16.1839 11.5469 15.9663 11.3239 15.9663 11.0488C15.9663 10.7738 16.1839 10.5508 16.4522 10.5508C16.7206 10.5508 16.9381 10.7738 16.9381 11.0488Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0489 10.3701C18.0489 10.5076 17.9401 10.6191 17.8059 10.6191C17.6718 10.6191 17.563 10.5076 17.563 10.3701C17.563 10.2326 17.6718 10.1211 17.8059 10.1211C17.9401 10.1211 18.0489 10.2326 18.0489 10.3701Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4796 10.7998C15.4796 10.9373 15.3708 11.0488 15.2366 11.0488C15.1024 11.0488 14.9937 10.9373 14.9937 10.7998C14.9937 10.6623 15.1024 10.5508 15.2366 10.5508C15.3708 10.5508 15.4796 10.6623 15.4796 10.7998Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1255 9.27637C14.1255 9.4139 14.0168 9.52539 13.8826 9.52539C13.7484 9.52539 13.6396 9.4139 13.6396 9.27637C13.6396 9.13884 13.7484 9.02734 13.8826 9.02734C14.0168 9.02734 14.1255 9.13884 14.1255 9.27637Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8062 12.1084C17.8062 12.2459 17.6974 12.3574 17.5633 12.3574C17.4291 12.3574 17.3203 12.2459 17.3203 12.1084C17.3203 11.9709 17.4291 11.8594 17.5633 11.8594C17.6974 11.8594 17.8062 11.9709 17.8062 12.1084Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5562 12.3574C16.5562 12.495 16.4474 12.6064 16.3133 12.6064C16.1791 12.6064 16.0703 12.495 16.0703 12.3574C16.0703 12.2199 16.1791 12.1084 16.3133 12.1084C16.4474 12.1084 16.5562 12.2199 16.5562 12.3574Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9788 11.4541C18.9788 11.6779 18.8017 11.8594 18.5834 11.8594C18.365 11.8594 18.188 11.6779 18.188 11.4541C18.188 11.2303 18.365 11.0488 18.5834 11.0488C18.8017 11.0488 18.9788 11.2303 18.9788 11.4541Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4942 12.6064C19.4942 12.744 19.3854 12.8555 19.2513 12.8555C19.1171 12.8555 19.0083 12.744 19.0083 12.6064C19.0083 12.4689 19.1171 12.3574 19.2513 12.3574C19.3854 12.3574 19.4942 12.4689 19.4942 12.6064Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.438 25.0625C29.438 29.7224 25.6604 33.5 21.0005 33.5C16.3406 33.5 12.563 29.7224 12.563 25.0625C12.563 20.4026 16.3406 16.625 21.0005 16.625C25.6604 16.625 29.438 20.4026 29.438 25.0625Z",
    fill: "#FFBB0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.063 25.0625C30.063 30.0676 26.0056 34.125 21.0005 34.125C15.9954 34.125 11.938 30.0676 11.938 25.0625C11.938 20.0574 15.9954 16 21.0005 16C26.0056 16 30.063 20.0574 30.063 25.0625ZM21.0005 33.5C25.6604 33.5 29.438 29.7224 29.438 25.0625C29.438 20.4026 25.6604 16.625 21.0005 16.625C16.3406 16.625 12.563 20.4026 12.563 25.0625C12.563 29.7224 16.3406 33.5 21.0005 33.5Z",
    fill: "#E89B05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.188 25.375C13.0154 25.375 12.8755 25.2351 12.8755 25.0625C12.8755 20.5752 16.5132 16.9375 21.0005 16.9375C21.1731 16.9375 21.313 17.0774 21.313 17.25C21.313 17.4226 21.1731 17.5625 21.0005 17.5625C16.8584 17.5625 13.5005 20.9204 13.5005 25.0625C13.5005 25.2351 13.3606 25.375 13.188 25.375Z",
    fill: "#E8AA0A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.813 24.75C28.9856 24.75 29.1255 24.8899 29.1255 25.0625C29.1255 29.5498 25.4878 33.1875 21.0005 33.1875C20.8279 33.1875 20.688 33.0476 20.688 32.875C20.688 32.7024 20.8279 32.5625 21.0005 32.5625C25.1426 32.5625 28.5005 29.2046 28.5005 25.0625C28.5005 24.8899 28.6404 24.75 28.813 24.75Z",
    fill: "#E8AA0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2505 25.0625C27.2505 28.5143 24.4523 31.3125 21.0005 31.3125C17.5487 31.3125 14.7505 28.5143 14.7505 25.0625C14.7505 21.6107 17.5487 18.8125 21.0005 18.8125C24.4523 18.8125 27.2505 21.6107 27.2505 25.0625Z",
    fill: "#FFDD28"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8755 25.0625C27.8755 28.8595 24.7974 31.9375 21.0005 31.9375C17.2035 31.9375 14.1255 28.8595 14.1255 25.0625C14.1255 21.2655 17.2035 18.1875 21.0005 18.1875C24.7974 18.1875 27.8755 21.2655 27.8755 25.0625ZM21.0005 31.3125C24.4523 31.3125 27.2505 28.5143 27.2505 25.0625C27.2505 21.6107 24.4523 18.8125 21.0005 18.8125C17.5487 18.8125 14.7505 21.6107 14.7505 25.0625C14.7505 28.5143 17.5487 31.3125 21.0005 31.3125Z",
    fill: "#E89B05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0005 30.375C23.9345 30.375 26.313 27.9965 26.313 25.0625C26.313 24.8899 26.4529 24.75 26.6255 24.75C26.7981 24.75 26.938 24.8899 26.938 25.0625C26.938 28.3417 24.2797 31 21.0005 31C20.8279 31 20.688 30.8601 20.688 30.6875C20.688 30.5149 20.8279 30.375 21.0005 30.375Z",
    fill: "#ECC704"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0005 19.75C18.0665 19.75 15.688 22.1285 15.688 25.0625C15.688 25.2351 15.5481 25.375 15.3755 25.375C15.2029 25.375 15.063 25.2351 15.063 25.0625C15.063 21.7833 17.7213 19.125 21.0005 19.125C21.1731 19.125 21.313 19.2649 21.313 19.4375C21.313 19.6101 21.1731 19.75 21.0005 19.75Z",
    fill: "#FFEF9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7461 27.562H20.6877V23.4824L19.4243 23.8743V23.0137L21.6326 22.2227H21.7461V27.562Z",
    fill: "#FFEF9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3711 27.562C22.3711 27.9072 22.0913 28.187 21.7461 28.187H20.6877C20.3426 28.187 20.0627 27.9072 20.0627 27.562V24.3306L19.6095 24.4712C19.4198 24.53 19.2134 24.4952 19.0536 24.3774C18.8937 24.2596 18.7993 24.0729 18.7993 23.8743V23.0137C18.7993 22.7498 18.9651 22.5143 19.2135 22.4253L21.4218 21.6343C21.4894 21.61 21.5607 21.5977 21.6326 21.5977H21.7461C22.0913 21.5977 22.3711 21.8775 22.3711 22.2227V27.562ZM20.6877 23.4824V27.562H21.7461V22.2227H21.6326L19.4243 23.0137V23.8743L20.6877 23.4824Z",
    fill: "#E89B05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_705_44727",
    x: 6,
    y: 6,
    width: 31.107,
    height: 31.107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.107,
    dy: 1.107
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.637788 0 0 0 0 0.545996 0 0 0 0 0.47948 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_705_44727"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_705_44727",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPrize);
export default __webpack_public_path__ + "static/media/firstPrize.faa1dcf8f6cec2108b4c54f3f6b56102.svg";
export { ForwardRef as ReactComponent };